
import { mapState, mapActions, mapGetters } from "vuex";
import RestaurantProfile from "../restaurant/restaurant-profile.vue";
import UserProfileAvatar from "../user/user-profile-avatar.vue";
import appVolumeHandler from "./app-volume-handler.vue";
// import SettingsButton from "../common/settings-button.vue";
import icon from "~/assets/images/icon.svg";
import ChatbotButton from "./chatbot-button.vue";
import CommunicationButton from "./communication-button.vue";
import ConfirmationDialog from "../dialogs/confirmation-dialog.vue";
export default {
  components: {
    appVolumeHandler,
    UserProfileAvatar,
    RestaurantProfile,
    ChatbotButton,
    CommunicationButton,
    ConfirmationDialog
    // SettingsButton,
  },
  data() {
    return {
      channelsPairedAndEmptyMenubook: true,
      clipped: false,
      showLogoutDialog: false,
      logoutWarningText: "",
      items: [
        {
          value: "biller",
          title: "Biller",
          to: "/biller"
        },
        {
          value: "receiver_app",
          title: "Receiver ",
          to: "/reciever"
        }
      ],
      hasLoaded: false,
      icon
    };
  },
  computed: {
    ...mapState("reciever", ["orders"]),
    ...mapState("menu", ["menuItems"]),
    ...mapState("restaurant", ["linkedApps", "locationDetails"]),
    ...mapGetters("payment", ["pendingInvoices"]),
    showMenuBookCoachMark() {
      return (
        this.locationDetails.coachmarks &&
        this.locationDetails.coachmarks.app_bar_menu &&
        this.hasLoaded &&
        !this.menuItems?.length
      );
    }
  },
  mounted() {
    setTimeout(() => {
      this.hasLoaded = true;
    }, 1000);
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    handleLogout() {
      if (this.$route.name === "menu-upload") {
        this.logoutWarningText =
          "You are about to be logged out of your account. If you proceed, all changes will be discarded. Are you sure you want to proceed with logout?";
        this.showLogoutDialog = true;
      } else {
        this.logout();
      }
    },
    isSubscribed(value) {
      if (!this.linkedApps) {
        return;
      }
      return this.linkedApps.find((app) => {
        return app.source == value;
      });
    }
  }
};
